import { createFileRoute, redirect } from '@tanstack/react-router'

import { AuthScreen, isAuthenticated, PasskeySetup, readPendingSetup } from '#/modules/auth'

function PasskeySetupPage() {
  return (
    <AuthScreen>
      <PasskeySetup />
    </AuthScreen>
  )
}

export const Route = createFileRoute('/login_/passkey')({
  beforeLoad: () => {
    if (isAuthenticated()) {
      throw redirect({ to: '/' })
    }
    // Only a sign-in that is waiting for a passkey has anything to do here.
    if (!readPendingSetup()) {
      throw redirect({ to: '/login' })
    }
  },
  component: PasskeySetupPage,
})
